module.exports = __webpack_public_path__ + "img/172424.c34ddd4e.png";